export default __webpack_public_path__ + "static/Chupa_Chups_Cola-d5e7ecc1ac789257b5a5bdb4c0c2e43b.png";